<template>
  <div class="container-fluid p-0">
    <div class="col-12 text-center">
      <button v-b-modal.createShift class="btn iconed btn-secondary m-3"><i
        class="icon-bd-plus"></i><span>تعریف شیفت</span></button>
      <button v-b-modal.createTimeShiftDay class="btn iconed btn-flickr m-3"><i
        class="icon-bd-building"></i><span>تعریف تقویم شیفت</span></button>
      <button v-b-modal.createTimeShiftDate class="btn iconed btn-danger m-3"><i
        class="icon-bd-edit"></i><span>تعریف روزهای خاص</span></button>
      <!--<button v-b-modal.getTimeShifts class="btn iconed btn-info m-3"><i-->
      <!--class="icon-calendar-blank-outline"></i><span>مشاهده تقویم</span></button>-->
      <date-picker
        v-show=true
        :highlight="highlightTimeShift"
        format="jYYYY-jMM-jDD"
        @input="setDateFromDatePicker"
        ref="datePicker3"
      >
        <slot>
          <button v-b-modal.getTimeShifts class="btn iconed btn-info m-3"><i
            class="icon-calendar-blank-outline"></i><span>مشاهده تقویم</span></button>
        </slot>
      </date-picker>
    </div>
    <!--<div class="col-lg-12 col-sm-6 my-5" v-if="showTimeShifts">-->
    <!--<div class="card shadow text-white  mb-1">-->
    <!--<div class="card-body pb-0">-->
    <!--<div class="card-chart">-->
    <!--<canvas id="bar-chart" width="1200" height="555"></canvas>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->


    <div class="col-12 text-center">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col" class="text-center">عملیات</th>
          <th scope="col" class="text-center">ردیف</th>
          <th scope="col" class="text-center">نام شیفت</th>
          <th scope="col" class="text-center">اولویت شیفت</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in shiftList">
          <td class="text-center">
            <button class="btn btn-secondary mx-2" @click="onEditClicked(item)"><i
              class="icon-bd-pencil"></i>
            </button>
            <button :id="'btn-delete-' + item.id" class="btn btn-secondary mx-2"
                    @click="onDeleteClicked(item)"><i
              class="icon-bd-delete"></i></button>
          </td>
          <th scope="row" class="text-center">{{item.id}}</th>
          <td class="text-center">{{item.name}}</td>
          <td class="text-center">{{item.priority}}</td>

        </tr>
        </tbody>
      </table>

      <!--<div class="col-12" v-if="showPagination">-->
      <!--<b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"-->
      <!--@input="nextPage(pageIndex)"/>-->
      <!--</div>-->
    </div>

    <!--------------------- TimeShifts ----------------------------------------->
    <div>

    </div>
    <!-------------------- MODALS ------------------------------------------>

    <b-modal
      id="createShift"
      ref="createShift"
      size="sm"
      :title="shiftEditMode ?
      'ویرایش شیفت'
      :
       'تعریف شیفت جدید'"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitShift"
    >


      <div class="row mb-2">
        <div class="col-12 my-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام شیفت</span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shiftName">
          </div>
        </div>
        <div class="col-12 my-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>اولویت شیفت</span>
              </div>
            </div>
            <input type="number" class="form-control" v-model="priority">
          </div>
        </div>
      </div>


    </b-modal>

    <b-modal
      id="createTimeShiftDay"
      ref="createTimeShiftDay"
      size="lg"
      title="تعریف تقویم شیفت"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitTimeShiftDay"
    >
      <div class="row mb-2">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب روز هفته</span>
              </div>
            </div>
            <vs-select
              ref="selectedDay"
              :isHeader="true"
              :data="dayOfWeekList"
              :selectedVal="dayOfWeekList.value"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="daySelect"
            ></vs-select>
          </div>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب شیفت</span>
              </div>
            </div>
            <vs-select
              ref="selectedDay"
              :isHeader="true"
              :data="shiftList"
              :selectedVal="shiftList.id"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="shiftSelect"
            ></vs-select>

          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="input-group col-6">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>ساعت شروع</span>
            </div>
          </div>

          <date-picker
            v-show=true
            type="time"
            initial-value="07:00"
            :jumpMinute="15"
            :roundMinute="true"
            format="HH:MM"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="startTime"
                class="form-control date-input"
                @click="toggleStartPicker"
              >
            </slot>
          </date-picker>
          <span>ساعت شروع شیفت(7:00)</span>
        </div>
        <div class="input-group col-6">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>ساعت پایان</span>
            </div>
          </div>

          <date-picker
            v-show=true
            type="time"
            :jumpMinute="60"
            :roundMinute="true"
            :min="startTime"
            format="HH:MM"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="endTime"
                class="form-control date-input"
                @click="toggleEndPicker"
              >
            </slot>
          </date-picker>
          <span>ساعت پایان شیفت(16:59 ساعت 17 را وارد نکنید)</span>
        </div>

      </div>


    </b-modal>

    <b-modal
      id="createTimeShiftDate"
      ref="createTimeShiftDate"
      size="lg"
      title="تعریف استثناء شیفت"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitTimeShiftDate"
    >
      <div class="row mb-2">

        <div class="input-group col-6">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>انتخاب روز</span>
            </div>
          </div>
          <date-picker
            v-show=true
            type="date"
            :auto-submit="true"
            format="YYYY-MM-DD"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="selectDate"
                class="form-control date-input"
                @click="toggleSelectDatePicker"
              >
            </slot>
          </date-picker>
        </div>
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>انتخاب شیفت</span>
              </div>
            </div>
            <vs-select
              ref="selectedDay"
              :isHeader="true"
              :data="shiftList"
              :selectedVal="shiftList.id"
              :header="{label:'name'}"
              :mode="'edit'"
              @dataChanged="shiftSelect"
            ></vs-select>

          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="input-group col-6">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>ساعت شروع</span>
            </div>
          </div>

          <date-picker
            v-show=true
            type="time"
            initial-value="07:00"
            :jumpMinute="15"
            :roundMinute="true"
            format="HH:MM"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="startTime"
                class="form-control date-input"
                @click="toggleStartPicker"
              >
            </slot>
          </date-picker>
        </div>
        <div class="input-group col-6">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>ساعت پایان</span>
            </div>
          </div>

          <date-picker
            v-show=true
            type="time"
            :jumpMinute="60"
            :roundMinute="true"
            :min="startTime"
            format="HH:MM"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="endTime"
                class="form-control date-input"
                @click="toggleEndPicker"
              >
            </slot>
          </date-picker>
        </div>

      </div>


    </b-modal>

    <b-modal
      id="getTimeShifts"
      ref="getTimeShifts"
      title="گزارش شیفتهای کاری"
      ok-title="مشاهده"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="submitGetTimeShifts"
    >

      <div class="row">
        <div class="input-group col-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>ابتدای بازه</span>
            </div>
          </div>
          <date-picker
            v-show=true
            :auto-submit="true"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="startDate"
                class="form-control date-input"
                @click="toggleStartDatePicker"
              >
            </slot>
          </date-picker>
        </div>

        <div class="input-group col-12 mt-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <i class="icon-calendar-blank-outline"></i>
              <span>پایان بازه</span>
            </div>
          </div>
          <date-picker
            v-show=true
            :min="startDate"
            :auto-submit="true"
            format="jYYYY-jMM-jDD"
            @input="setDateFromDatePicker"
            ref="datePicker"
          >
            <slot>
              <input
                :readonly=true
                v-model="endDate"
                class="form-control date-input"
                @click="toggleEndDatePicker"
              >
            </slot>
          </date-picker>
        </div>

      </div>

    </b-modal>


    <!-------------------------------------------------------------->
  </div>
</template>


<script>
  import VsTable from "../../_framework/VsTable.vue";
  import Utils from "../../_framework/utils/Utils";
  import BaseService from "../../_framework/api/BaseService";
  import VsSelect from "../../_framework/VsSelect";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Moment from "moment-jalali";

  export default {
    name: "shifting",
    created: () => {
    },
    components: {
      VsTable,
      datePicker: DatePicker,
      VsSelect
    },
    data() {
      return {
        show: true,
        access: {},
        shiftList: [],
        shiftEditMode: false,
        shiftId: 0,
        shiftName: "",
        priority: 1,
        dayOfWeekList: [],
        selectedDay: {
          value: 0,
          name: null,
          shifts: null,
          timeShifts: null,
          createdOn: null,
        },
        selectedShift: {
          id: 0,
          name: null,
        },
        createTimeShiftModel: {
          StartTime: null,
          EndTime: null,
          DayofWeek: 10,
          ShiftingId: 0,
          Date: "2020-01-01"
        },
        dateClicked: 0,
        startTime: null,
        endTime: null,
        selectDate: null,
        isShowCalendar: false,
        startDate: null,
        endDate: null,
        showTimeShifts: false,
        timeShifts: [],


      };
    },
    beforeMount() {
      this.show = true;
      this.refreshTable();
      this.getDayOfWeek();
    },
    methods: {
      getDayOfWeek() {
        this.dayOfWeekList = [];
        this.dayOfWeekList.push({name: "شنبه", value: 6});
        this.dayOfWeekList.push({name: "یکشنبه", value: 0});
        this.dayOfWeekList.push({name: "دوشنبه", value: 1});
        this.dayOfWeekList.push({name: "سه شنبه", value: 2});
        this.dayOfWeekList.push({name: "چهارشنبه", value: 3});
        this.dayOfWeekList.push({name: "پنجشنبه", value: 4});
        this.dayOfWeekList.push({name: "جمعه", value: 5});
      },
      refreshTable() {
        new BaseService('Time', '/GetShift').getList().then((response) => {
          this.shiftList = response.data;

        }).catch((error) => {
          console.log(error)
        });
      },
      submitShift() {

        if (this.shiftName === null || this.shiftName == "") {
          Utils.handleErrorWithNotification("نام را با دقت وارد کنید", this.$noty);
        } else {
          let param = {
            id: this.shiftId,
            name: this.shiftName,
            priority: this.priority
          };
          if (this.shiftEditMode) {
            this.shiftEditMode = false;
            new BaseService('Time', '/EditShift').update(param).then((response) => {
              this.$noty.success("شیفت با موفقیت ویرایش شد");
              this.refreshTable();
            }).catch((error) => {
              console.log(error)
            });
          } else {
            new BaseService('Time', '/AddShift').create(param).then((response) => {
              this.$noty.success("شیفت با موفقیت ثبت شد");
              this.refreshTable();
            }).catch((error) => {
              console.log(error)
            });
          }
        }
      },
      submitTimeShiftDay() {
        if (this.createTimeShiftModel.StartTime === null) {
          Utils.handleErrorWithNotification("ساعت شروع را با دقت وارد کنید", this.$noty);
        } else if (this.createTimeShiftModel.EndTime === null) {
          Utils.handleErrorWithNotification("ساعت پایان را با دقت وارد کنید", this.$noty);
        } else if (this.createTimeShiftModel.ShiftingId === null || this.createTimeShiftModel.ShiftingId === 0) {
          Utils.handleErrorWithNotification("شیفت را با دقت وارد کنید", this.$noty);
        } else if (this.createTimeShiftModel.DayofWeek === null) {
          Utils.handleErrorWithNotification("روز را با دقت وارد کنید", this.$noty);
        } else {
          new BaseService('Time', '/AddTimeShift').create(this.createTimeShiftModel).then((response) => {
            this.$noty.success("شیفت با موفقیت ثبت شد");
            // console.log(response.data)
          }).catch((error) => {
            console.log(error)
          });
        }

      },
      submitTimeShiftDate() {
        if (this.createTimeShiftModel.StartTime === null) {
          Utils.handleErrorWithNotification("ساعت شروع را با دقت وارد کنید", this.$noty);
        } else if (this.createTimeShiftModel.EndTime === null) {
          Utils.handleErrorWithNotification("ساعت پایان را با دقت وارد کنید", this.$noty);
        } else if (this.createTimeShiftModel.ShiftingId === null || this.createTimeShiftModel.ShiftingId === 0) {
          Utils.handleErrorWithNotification("شیفت را با دقت وارد کنید", this.$noty);
        } else if (this.createTimeShiftModel.Date === null) {
          Utils.handleErrorWithNotification("روز را با دقت وارد کنید", this.$noty);
        } else {
          this.createTimeShiftModel.DayofWeek = 9;
          let date = Moment(this.createTimeShiftModel.Date, "jYYYY/jMM/jDD");
          this.createTimeShiftModel.Date = date.format("YYYY-MM-DD");
          new BaseService('Time', '/AddTimeShift').create(this.createTimeShiftModel).then((response) => {
            this.$noty.success("شیفت با موفقیت ثبت شد");
            // console.log(response.data)
          }).catch((error) => {
            console.log(error)
          });
        }

      },
      resetModal() {
        // this.shiftName = '';
      },
      onEditClicked(val) {
        console.log(val.name)
        this.shiftId = val.id;
        this.shiftName = val.name;
        this.priority = val.priority;
        this.shiftEditMode = true;
        console.log(this.shiftName)
        setTimeout(() => {
          this.$refs['createShift'].show()
        }, 50)
      },
      onDeleteClicked(val) {
        console.log(val);
        let param = {
          name: val.name,
          id: val.id
        };
        new BaseService('Time', '/DeleteShift').create(param).then((response) => {
          this.$noty.success("شیفت با موفقیت حذف شد");
          // console.log(response.data)
        }).catch((error) => {
          Utils.handleErrorWithNotification("" + error, this.$noty);
          console.log(error)
        });
      },
      daySelect(prop, data) {
        this.createTimeShiftModel.DayofWeek = data.value;
        console.log(data);
        // this.parameters.patternId = data.id;
        // console.log(this.parameters.patternId);

        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      shiftSelect(prop, data) {
        this.createTimeShiftModel.ShiftingId = data.id;
        console.log(data);
        // this.parameters.patternId = data.id;
        // console.log(this.parameters.patternId);

        // if (data && data.id) {
        //   this.voucherModel.documentTypeId = data.id;
        // } else {
        //   this.voucherModel.documentTypeId = null;
        // }
      },
      toggleStartPicker() {
        console.log("satrt");
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      toggleStartDatePicker() {
        this.dateClicked = 5;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndDatePicker() {
        this.dateClicked = 6;
        this.$refs.datePicker.togglePicker();
      },
      toggleEndPicker() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },
      toggleSelectDatePicker() {
        this.dateClicked = 3;
        this.$refs.datePicker.type = "date";
        this.$refs.datePicker.format = "jYYYY-jMM-jDD";
        this.$refs.datePicker.togglePicker();
      },
      setDateFromDatePicker(date) {
        if (this.dateClicked === 1) {
          var st = date;
          st = st.replace(':04', ':00');
          this.startTime = st;
          this.createTimeShiftModel.StartTime = date;
        }
        if (this.dateClicked === 2) {
          var st = date;
          st = st.replace(':04', ':59');
          this.endTime = st;
          this.createTimeShiftModel.EndTime = date;
        }
        if (this.dateClicked === 3) {
          this.selectDate = date;
          this.createTimeShiftModel.Date = date;
        }
        if (this.dateClicked === 5) {
          this.startDate = date;
        }
        if (this.dateClicked === 6) {
          this.endDate = date;
        }
      },
      showCalendar() {
        this.isShowCalendar = !this.isShowCalendar;
        console.log(this.isShowCalendar);
      },
      highlight(formatted, dateMoment, checkingFor) {


        let attributes = {'title': 'بدون تعریف' + formatted};
        for (let i = 0; i < this.disableDates.length; i++) {
          if (checkingFor === 'day' && formatted === this.disableDates[i]) {
            // console.log("28")
            attributes['style'] = 'background-color: #f9e1be !important; ';
            attributes['title'] = 'این روز در تقویم کاری تعریف شده است';
          }
        }
        // if (checkingFor === 'day' && formatted === '1399-02-28'){
        //   console.log("28")
        //   attributes['style'] = 'color: #EF6C00 !important; background-color: #f9e1be !important; border: solid 1px #EF6C00;';
        //   attributes['title'] = 'جشن چهارشنبه سوری';
        // }
        // if (checkingFor === 'day' && formatted === '1399-02-29'){
        //   console.log("29")
        //   attributes['style'] = 'background-color: #e91600 !important;';
        //   attributes['title'] = 'روز ملی شدن صنعت نفت';
        // }
        // if (checkingFor === 'day' && formatted === '2020-05-08'){
        //   console.log("29")
        //   attributes['style'] = 'background-color: #e91600 !important;';
        //   attributes['title'] = 'روز ملی شدن صنعت نفت';
        // }
        return attributes;
      },
      highlightTimeShift(formatted, dateMoment, checkingFor) {


        let attributes = {'title': 'بدون شیفت'};
        for (let i = 0; i < this.timeShifts.length; i++) {
          if (checkingFor === 'day' && formatted === this.timeShifts[i].date) {
            // console.log("28")
            attributes['style'] = 'background-color: #f9e1be !important; ';
            let str = "";
            for (let j = 0; j < this.timeShifts[i].shifts.length; j++) {
              str = str + ' | ' + this.timeShifts[i].shifts[j].name + ' ' + this.timeShifts[i].shifts[j].times;
            }
            attributes['title'] = str;
          }
        }
        // if (checkingFor === 'day' && formatted === '1399-02-28'){
        //   console.log("28")
        //   attributes['style'] = 'color: #EF6C00 !important; background-color: #f9e1be !important; border: solid 1px #EF6C00;';
        //   attributes['title'] = 'جشن چهارشنبه سوری';
        // }
        // if (checkingFor === 'day' && formatted === '1399-02-29'){
        //   console.log("29")
        //   attributes['style'] = 'background-color: #e91600 !important;';
        //   attributes['title'] = 'روز ملی شدن صنعت نفت';
        // }
        // if (checkingFor === 'day' && formatted === '2020-05-08'){
        //   console.log("29")
        //   attributes['style'] = 'background-color: #e91600 !important;';
        //   attributes['title'] = 'روز ملی شدن صنعت نفت';
        // }
        return attributes;
      },
      submitGetTimeShifts() {
        if (this.startDate !== null && this.endDate !== null) {
          let date = Moment(this.startDate, "jYYYY/jMM/jDD");
          this.startDate = date.format("YYYY-MM-DD");
          let date2 = Moment(this.endDate, "jYYYY/jMM/jDD");
          this.endDate = date2.format("YYYY-MM-DD");
          let createTimesheet = {
            startDate: (this.startDate),
            endDate: (this.endDate)
          };
          console.log(createTimesheet);
          new BaseService('Time', '/GetTimeShifts').create(createTimesheet).then((response) => {
            this.timeShifts = response.data;
            for (let i = 0; i < this.timeShifts.length; i++) {
              // console.log(this.timeSheets[i].dateTime);
              this.timeShifts[i].date = Moment(this.timeShifts[i].date.substring(0, 10), "YYYY-MM-DD").format("jYYYY-jMM-jDD");
            }
            // this.$noty.success("لطفا چند لحظه صبر کنید...");
            console.log(this.timeShifts);
            this.$refs.datePicker3.togglePicker();
            this.showTimeShifts = true;
            // var ctx = document.getElementById('bar-chart').getContext('2d');
            // var myChart = new Chart(ctx, {
            //   type: 'bar',
            //   data: {
            //     labels: this.timeShifts.date,
            //     datasets: [
            //       {
            //         label: 'در انتظار',
            //         data: this.workshopChartData.data.inQueue,
            //         backgroundColor: 'rgba(255,193,7,0.71)',
            //         borderColor: "rgba(255,143,0,0.71)"
            //       },
            //       {
            //         label: 'درحال انجام',
            //         data: this.workshopChartData.data.doing,
            //         backgroundColor: 'rgba(205,220,57,0.71)',
            //         borderColor: "rgba(135,150,40,0.71)"
            //       },
            //       {
            //         label: 'مشکل',
            //         data: this.workshopChartData.data.problem,
            //         backgroundColor: 'rgba(249,60,103,0.71)',
            //         borderColor: "rgba(198,40,40,0.71)"
            //       },
            //       {
            //         label: 'انجام شده',
            //         data: this.workshopChartData.data.done,
            //         backgroundColor: 'rgba(3,169,244,0.71)',
            //         borderColor: "rgba(3,169,244,0.71)"
            //       },
            //       {
            //         label: 'تایید شده',
            //         data: this.workshopChartData.data.confirm,
            //         backgroundColor: 'rgba(76,175,80,0.71)',
            //         borderColor: "rgba(76,175,80,0.7)"
            //       }
            //     ]
            //   }, options: {
            //     scales: {
            //       xAxes: [{
            //         stacked: true
            //       }],
            //       yAxes: [{
            //         stacked: true
            //       }]
            //     },
            //     title: {
            //       display: true,
            //       text: 'شیفتها و ساعات کاری'
            //     },
            //   }
            //
            // });


          }).catch((error) => {
            Utils.handleErrorWithNotification("" + error, this.$noty);
            console.log(error);
          });
          this.startDate = null;
          this.endDate = null;
        }
      },
    }
  };
</script>
